/* LEGELAND Olive Oil landing page – progressive enhancement, no dependencies.
   Every section works without this file; the script only adds motion and AJAX add-to-cart. */
(() => {
  if (window.__lglOil) return;
  window.__lglOil = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    const targets = $$('[data-reveal]', root).filter((el) => !el.classList.contains('is-in'));
    if (!targets.length) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-in'));
      return;
    }
    // Content already on screen stays put (no flash); only what is below the fold animates in.
    const vh = window.innerHeight;
    targets.forEach((el) => { if (el.getBoundingClientRect().top < vh) el.classList.add('is-in'); });
    $$('.lgl', root).forEach((s) => s.classList.add('js-reveal'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.filter((el) => !el.classList.contains('is-in')).forEach((el) => io.observe(el));
  }

  /* ---------- Subtle parallax (hero stage only) ---------- */
  function initParallax(root) {
    const layers = $$('[data-parallax]', root);
    if (!layers.length || reduceMotion.matches) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      layers.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const progress = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(${el.classList.contains('lgl-stage__products') ? '-50%' : '0'}, ${(progress * parseFloat(el.dataset.parallax) * 600).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Accessible tabs (flavour profile) ---------- */
  function wireTabs(tablist, onSelect) {
    const tabs = $$('[role="tab"]', tablist);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      onSelect?.(tabs.indexOf(tab), tab);
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (e) => {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (e.key in keys) { e.preventDefault(); select(tabs[(i + keys[e.key] + tabs.length) % tabs.length], true); }
        if (e.key === 'Home') { e.preventDefault(); select(tabs[0], true); }
        if (e.key === 'End') { e.preventDefault(); select(tabs[tabs.length - 1], true); }
      });
    });
    return { tabs, select };
  }

  function initTabs(root) {
    $$('[data-lgl-tabs] [role="tablist"]', root).forEach((list) => wireTabs(list));
  }

  /* ---------- LEGELAND system stepper ---------- */
  function initSystem(root) {
    $$('[data-lgl-system]', root).forEach((sys) => {
      const list = sys.querySelector('[role="tablist"]');
      if (!list) return;
      const STEP_MS = 4800;
      sys.style.setProperty('--lgl-step-ms', `${STEP_MS}ms`);
      let timer = null;
      let visible = false;
      let paused = sys.dataset.autoplay === 'false' || reduceMotion.matches;
      const pauseBtn = sys.querySelector('[data-lgl-pause]');

      const { tabs, select } = wireTabs(list, (index, tab) => {
        sys.dataset.step = tab.dataset.step || index + 1;
        restart();
      });
      const current = () => tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const stop = () => { clearTimeout(timer); sys.classList.remove('is-playing'); };
      function restart() {
        stop();
        if (paused || !visible) return;
        // Force the progress bar animation to restart.
        sys.classList.remove('is-playing'); void sys.offsetWidth; sys.classList.add('is-playing');
        timer = setTimeout(() => select(tabs[(current() + 1) % tabs.length], false), STEP_MS);
      }
      const setPaused = (value) => {
        paused = value;
        pauseBtn?.setAttribute('aria-pressed', String(value));
        restart();
      };
      // Any manual interaction stops autoplay for good: the visitor is in control now.
      tabs.forEach((t) => t.addEventListener('click', (e) => { if (e.isTrusted) setPaused(true); }));
      pauseBtn?.addEventListener('click', () => setPaused(!paused));
      if (paused) pauseBtn?.setAttribute('aria-pressed', 'true');
      sys.addEventListener('focusin', stop);
      sys.addEventListener('focusout', restart);
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; restart(); }, { threshold: 0.35 }).observe(sys);
    });
  }

  /* ---------- Add to cart (Shopify AJAX API + Focal cart events) ---------- */
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initProducts(scope) {
    $$('[data-lgl-atc]', scope).forEach((form) => {
      const variants = JSON.parse(form.querySelector('[data-lgl-variants]')?.textContent || '[]');
      const input = form.querySelector('[data-lgl-variant-input]');
      const price = form.querySelector('[data-lgl-price]');
      const compare = form.querySelector('[data-lgl-compare]');
      const unit = form.querySelector('[data-lgl-unit]');
      const stock = form.querySelector('[data-lgl-stock]');
      const btn = form.querySelector('[data-lgl-add]');
      const label = form.querySelector('[data-lgl-add-label]');
      const msg = form.querySelector('[data-lgl-msg]');
      const d = form.dataset;
      const texts = { add: d.tAdd || 'In den Warenkorb', soldout: d.tSoldout || 'Ausverkauft', inStock: d.tIn || 'Verfügbar', outStock: d.tOut || 'Derzeit ausverkauft', added: d.tAdded || 'Im Warenkorb ✓', error: d.tError || 'Das hat nicht geklappt. Bitte versuche es erneut.' };

      input?.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === input.value);
        if (!v) return;
        price.textContent = v.price;
        if (compare) { compare.hidden = !v.compare; compare.textContent = v.compare || ''; }
        if (unit) { unit.hidden = !v.unit; unit.textContent = v.unit || ''; }
        stock.dataset.available = v.available;
        stock.textContent = v.available ? texts.inStock : texts.outStock;
        btn.disabled = !v.available;
        label.textContent = v.available ? texts.add : texts.soldout;
      });

      form.addEventListener('submit', async (e) => {
        if (!window.fetch) return;
        e.preventDefault();
        btn.classList.add('is-loading');
        msg.textContent = '';
        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || texts.error);
          const cart = await fetch(`${root}cart.js`).then((r) => r.json());
          msg.textContent = texts.added;
          // Focal listens to these events to re-render and open the cart drawer.
          const detail = { variant: data.items?.[0], cart };
          document.documentElement.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          // No drawer in the theme (or drawer disabled): go to the cart page.
          if (!document.querySelector('cart-drawer, #mini-cart, [data-cart-drawer]')) window.location.href = `${root}cart`;
        } catch (err) {
          msg.textContent = err.message || texts.error;
        } finally {
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  /* ---------- Mobile sticky buy bar ---------- */
  function initSticky(scope) {
    $$('[data-lgl-sticky]', scope).forEach((bar) => {
      const shop = bar.closest('.lgl-shop');
      const hero = document.querySelector('.lgl-hero');
      bar.hidden = false;
      let heroVisible = true;
      let shopVisible = false;
      const update = () => bar.classList.toggle('is-visible', !heroVisible && !shopVisible);
      if (hero) new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; update(); }).observe(hero);
      else heroVisible = false;
      new IntersectionObserver(([e]) => { shopVisible = e.isIntersecting; update(); }, { threshold: 0.05 }).observe(shop);
      update();
    });
  }

  /* ---------- QR entry: ?qr=1 or utm_medium=qr shows the quick links ---------- */
  function initQr() {
    const p = new URLSearchParams(window.location.search);
    if (!(p.has('qr') || p.get('utm_medium') === 'qr')) return;
    $$('[data-lgl-qr]').forEach((el) => { el.hidden = false; el.closest('.lgl')?.classList.add('lgl-qr-mode'); });
  }

  /* ---------- Ambient video: plays muted while visible, pause button, no autoplay with reduced motion ---------- */
  function initVideos(scope) {
    $$('[data-lgl-video]', scope).forEach((fig) => {
      if (fig.dataset.lglReady) return;
      fig.dataset.lglReady = '1';
      const video = fig.querySelector('video');
      const btn = fig.querySelector('[data-lgl-video-toggle]');
      let paused = reduceMotion.matches;
      let visible = false;
      const sync = () => {
        btn?.setAttribute('aria-pressed', String(paused));
        if (!paused && visible) video.play().catch(() => {});
        else video.pause();
      };
      btn?.addEventListener('click', () => { paused = !paused; sync(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(fig);
      } else { visible = true; }
      sync();
    });
  }

  /* ---------- Smooth in-page anchors (respecting reduced motion) ---------- */
  function initAnchors() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('.lgl a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      const target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href') + '');
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }

  function init(scope = document) {
    initReveal(scope);
    initParallax(scope);
    initTabs(scope);
    initSystem(scope);
    initProducts(scope);
    initSticky(scope);
    initVideos(scope);
  }

  const boot = () => { init(); initQr(); initAnchors(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-initialise a section after it was re-rendered.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
